export default __webpack_public_path__ + "static/media/Plane.08c439c9.png";